import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ROOMS } from "../config/rooms";

function Rooms() {
  return (
    <div className="min-h-screen">
      {/* Banner */}
      <div className="relative h-[40vh] min-h-[220px] w-full overflow-hidden bg-gradient-to-br from-amber-600 to-amber-900">
        <div className="absolute inset-0 flex flex-col justify-center items-center text-white text-center px-4">
          <motion.h1
            className="text-2xl md:text-4xl font-fancy tracking-wide"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            Rooms +
          </motion.h1>
          <motion.p
            className="text-lg md:text-xl mt-2 text-amber-100"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2 }}
          >
            Chuti Resort Purbachal
          </motion.p>
        </div>
      </div>

      {/* Room cards */}
      <div className="max-w-5xl mx-auto px-4 py-12">
        <h2 className="text-2xl font-bold text-center text-gray-800 mb-8 font-fancy">Choose your room</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {ROOMS.map((room, index) => (
            <motion.div
              key={room.slug}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.08 }}
            >
              <Link
                to={`/rooms/${room.slug}`}
                className="block bg-white rounded-xl shadow-lg hover:shadow-xl border border-gray-100 overflow-hidden transition-all duration-300 hover:-translate-y-1"
              >
                <div className="aspect-[4/3] bg-gradient-to-br from-amber-100 to-yellow-50 flex items-center justify-center">
                  {room.images.length > 0 ? (
                    <img
                      src={room.images[0]}
                      alt={room.name}
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <svg className="w-14 h-14 text-amber-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                  )}
                </div>
                <div className="p-4">
                  <h3 className="text-lg font-bold text-gray-800 font-fancy">{room.name}</h3>
                  <span className="text-amber-600 text-sm font-medium mt-1 inline-block">View details →</span>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Rooms;
